import {inject, Injectable} from '@angular/core';
import {NavigationEnd, NavigationSkipped, NavigationSkippedCode, Router} from '@angular/router';
import {Actions, ofType} from '@ngrx/effects';
import {auditTime, catchError, distinctUntilChanged, filter, map, merge, of, shareReplay, startWith, switchMap} from 'rxjs';
import {AuthService} from '../auth/auth.service';
import {BasketService} from '../basket/basket.service';
import {FavoritesService} from '../favorites/favorites.service';
import {ReportsActions} from '../reports/store/reports.actions';
import {EventsService} from './events.service';

@Injectable({providedIn: 'root'})
export class EventJournalCountService {
  private readonly auth = inject(AuthService);
  private readonly events = inject(EventsService);
  private readonly router = inject(Router);
  private readonly actions = inject(Actions);
  private readonly basket = inject(BasketService);
  private readonly favorites = inject(FavoritesService);
  private readonly refreshes = merge(
    this.router.events.pipe(filter(event => event instanceof NavigationEnd ||
      (event instanceof NavigationSkipped && event.code === NavigationSkippedCode.IgnoredSameUrlNavigation))),
    this.actions.pipe(ofType(ReportsActions.applicationStarted, ReportsActions.applicationResumed,
      ReportsActions.inventoryMutationCompleted, ReportsActions.refreshRequested)),
    this.basket.changes$, this.favorites.changes,
  );
  readonly count$ = this.auth.session$.pipe(
    map(session => session?.user.id ?? ''), distinctUntilChanged(),
    switchMap(userId => userId ? this.refreshes.pipe(
      startWith(undefined), auditTime(25),
      switchMap(() => this.events.count().pipe(map(result => result.count), catchError(() => of(null)), startWith(null))),
      startWith(null),
    ) : of(null)),
    shareReplay({bufferSize: 1, refCount: true}),
  );
}
